import React, { Component } from 'react';
import PropTypes from 'prop-types';

class GoogleAd extends Component {
  googleInit = null;

  componentDidMount() {
    const { timeout } = this.props;
    this.googleInit = setTimeout(() => {
      if (typeof window !== 'undefined')
        (window.adsbygoogle = window.adsbygoogle || []).push({});
    }, timeout);
  }

  componentWillUnmount() {
    console.log("cargando anuncio")
    if (this.googleInit) clearTimeout(this.googleInit);
  }

  render() {
    const { classNames, slot, googleAdId, format, width, height, float } = this.props;
    return (
      <div className={classNames}>
        <ins
          className="adsbygoogle"
          style={{ 
            width: width || 500, 
            height: height || 300, 
            float: float || 'left',
            display: 'block'
          }}
          data-ad-client={googleAdId}
          data-ad-slot={slot}
          data-ad-format={format || "auto"}
          data-full-width-responsive="true"
        ></ins>
      </div>
    );
  }
}

GoogleAd.propTypes = {
  classNames: PropTypes.string,
  slot: PropTypes.string,
  timeout: PropTypes.number,
  googleAdId: PropTypes.string,
  width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  height: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  float: PropTypes.string,
  format: PropTypes.string,
};

GoogleAd.defaultProps = {
  classNames: '',
  timeout: 200,
  width: 500,
  height: 300,
  float: 'none',
};

export default GoogleAd;